// Auto-generated cornerstone translation for pl.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:36:34.096997+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aplikacja do zarządzania końmi: najlepszy wybór na 2026 | EquiSight",
      description: "Porównaj aplikacje do zarządzania końmi dla właściciela, stajni i hodowli. Odkryj, dlaczego EquiSight to kompletna aplikacja dla Twojego konia.",
      keywords: [
        "aplikacja do zarządzania końmi",
        "aplikacja do zarządzania stajnią",
        "dziennik konia aplikacja",
        "aplikacja do zarządzania wieloma końmi",
        "aplikacja ciąża klaczy",
        "aplikacja hodowlana konie",
        "najlepsza aplikacja do zarządzania końmi",
      ],
    },
    hero: {
      eyebrow: "Pomoc w wyborze · oprogramowanie do zarządzania końmi",
      breadcrumbLabel: "Aplikacja do zarządzania końmi",
      title: "Aplikacja do zarządzania końmi: kompletny przewodnik dla właścicieli, stajni i hodowli.",
      intro: "To nie jest zwykła lista funkcji — to uczciwe porównanie, pomoc w wyborze i spojrzenie na to, czego aplikacja do zarządzania końmi naprawdę potrzebuje w 2026 roku. Dla jednego konia, całej stajni lub Twojej hodowli.",
      pills: [
        {
          icon: "Users",
          label: "Dla właścicieli",
        },
        {
          icon: "Building2",
          label: "Dla stajni",
        },
        {
          icon: "Baby",
          label: "Dla hodowców",
        },
        {
          icon: "Share2",
          label: "Dla zespołów",
        },
      ],
      ctas: [
        {
          label: "Zacznij bezpłatnie z 1 koniem",
          href: "#start",
          primary: true,
        },
        {
          label: "Przejdź do tabeli porównawczej",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Dlaczego aplikacja do zarządzania końmi staje się coraz ważniejsza.",
      lead: "Zarządzanie końmi jest w praktyce rozproszone: WhatsApp, kalendarz, Excel, zdjęcia w telefonie, papierowy paszport, luźne faktury i ustne ustalenia. Już przy jednym koniu to niewygodne. Przy kilku koniach, hodowlach lub wspólnej opiece pojawiają się luki, pominięte terminy i nieporozumienia.",
      items: [
        "Gdzie była ta data szczepienia?",
        "Kto zapłacił kowalowi?",
        "Która klacz powinna być dziś sprawdzona?",
        "Czy trener przeczytał instrukcję z zeszłego tygodnia?",
        "Czy naprawdę zapisałem ten dokument ze zdjęciem?",
        "Czy plan żywienia wiszący w stajni jest jeszcze aktualny?",
      ],
    },
    what: {
      title: "Czym jest aplikacja do zarządzania końmi?",
      lead: "Aplikacja do zarządzania końmi to w zasadzie cyfrowe dossier dla każdego konia. Żadnych rozproszonych notatek — tylko jedno miejsce na zdrowie, trening, żywienie, dokumenty, planowanie, przypomnienia, koszty, zdjęcia, filmy i współdzielony dostęp. Wszyscy zaangażowani w opiekę nad koniem widzą te same, aktualne informacje.",
      targetGroupsTitle: "Dla kogo jest aplikacja do zarządzania końmi?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Prywatny właściciel",
          body: "Jeden koń, jedno dossier — zdrowie, planowanie i historia w kieszeni.",
        },
        {
          icon: "Users",
          title: "Właściciel wielu koni",
          body: "Osobne profile, osobne planowanie, wspólna lista zadań dla całego zespołu.",
        },
        {
          icon: "Building2",
          title: "Stajnia pensjonatowa i ujeżdżalnia",
          body: "Dostęp dla właściciela, instrukcje pielęgnacji, wspólny kalendarz i zadania.",
        },
        {
          icon: "Baby",
          title: "Hodowla",
          body: "Cykl klaczy, ciąża, dane ogiera, rodowód i rozwój źrebięcia.",
        },
        {
          icon: "Target",
          title: "Trenerzy",
          body: "Wgląd w każdego konia, rejestrowanie sesji, wyznaczanie celów, analiza wideo.",
        },
        {
          icon: "ClipboardList",
          title: "Profesjonaliści",
          body: "Kowal, dentysta, fizjoterapeuta lub weterynarz — pracują z tego samego dossier.",
        },
      ],
    },
    criteria: {
      title: "Czego powinna spełniać dobra aplikacja do zarządzania końmi?",
      lead: "Aplikacja to nie tylko ładny wygląd — musi działać praktycznie na co dzień. Pięć elementów, których nie może zabraknąć przy wyborze w 2026 roku.",
      items: [
        {
          icon: "FileText",
          title: "Dossier dla każdego konia",
          body: "Dane, wiek, rasa, informacje paszportowe, właściciel, stajnia, zdjęcia i dokumenty — wszystko powiązane z jednym profilem konia.",
        },
        {
          icon: "Heart",
          title: "Zdrowie i pielęgnacja",
          body: "Szczepienia, odrobaczanie, kowal, dentysta, weterynarz, zabiegi, leki i automatyczne przypomnienia przed terminem ważności.",
        },
        {
          icon: "Activity",
          title: "Trening i postęp",
          body: "Rejestrowanie treningów, notatki, filmy, wyniki zawodów, cele i postępy według dyscypliny lub konia.",
        },
        {
          icon: "Apple",
          title: "Żywienie i zarządzanie",
          body: "Plany żywienia, suplementy, siano, waga, kondycja ciała i codzienna rutyna, którą stajnia musi znać.",
        },
        {
          icon: "Share2",
          title: "Udostępnianie innym",
          body: "Dostęp dla właściciela, opiekuna, trenera, właściciela stajni lub profesjonalisty — z zarządzaniem uprawnieniami dopasowanym do roli każdej osoby.",
        },
        {
          icon: "Calendar",
          title: "Planowanie i przypomnienia",
          body: "Wspólny kalendarz z zadaniami, automatycznymi przypomnieniami i potwierdzeniami, żeby nic nie umknęło.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs inne aplikacje do zarządzania końmi.",
      lead: "Polskie i europejskie wyniki wyszukiwania wypełniają Stalmanager, LogMyHorse, EquineM i Happie Horse. Każda z nich ma swoje mocne strony. Zestawiamy obok siebie najczęściej poszukiwane funkcje — uczciwie i na podstawie publicznie dostępnych informacji.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Bezpłatny start",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Wiele koni",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumentacja zdrowotna",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Trening i postęp",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Żywienie i suplementy",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planowanie i przypomnienia",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenty dla każdego konia",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Udostępnianie zespołowi i uprawnienia",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Moduł hodowlany (kompletny)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cykl klaczy",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Planowanie ciąży i badania USG",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Rozwój źrebięcia",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integracja z profesjonalistami",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Wnioski EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Odpowiednie dla właściciela",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Odpowiednie dla hodowli",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Odpowiednie dla stajni/ujeżdżalni",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Porównanie na podstawie publicznie dostępnych funkcji ze stycznia 2026. Konkurencyjne aplikacje to również dobre narzędzia; EquiSight został zbudowany po to, aby łączyć wszystkie moduły w jednej aplikacji.",
    },
    why: {
      title: "Dlaczego EquiSight jest inny.",
      lead: "Dziennik tylko rejestruje. EquiSight łączy zarządzanie końmi, trening, żywienie, zdrowie, zawody, profesjonalistów i hodowlę w jednej nowoczesnej aplikacji — i idzie o krok dalej dzięki analizom.",
      points: [
        {
          icon: "Heart",
          title: "Jedna aplikacja na całe życie konia",
          body: "Od źrebięcia po konia sportowego, klacz hodowlaną lub konia na emeryturze. Dossier rośnie razem z koniem — nic nie ginie po drodze.",
        },
        {
          icon: "Sparkles",
          title: "Nie tylko dane, ale też wzorce",
          body: "EquiCoach łączy rozwój, nawracające dolegliwości, trening i żywienie — abyś na czas dostrzegał sygnały, a nie tylko pojedyncze zdarzenia.",
        },
        {
          icon: "Share2",
          title: "Zbudowany do współpracy",
          body: "Właściciel, właściciel stajni, trener, kowal i inni profesjonaliści pracują z tego samego dossier konia — z uprawnieniami dopasowanymi do ich roli.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niszowe rozwiązanie · hodowla",
      title: "Zarządzanie końmi dla hodowców.",
      lead: "Wielu konkurentów wspomina hodowlę w jednym zdaniu. EquiSight zbudował kompletny moduł hodowlany — ponieważ hodowca rzadko jest typowym użytkownikiem ogólnej aplikacji, a jego potrzeby planistyczne są większe niż kogokolwiek innego.",
      items: [
        "Codzienny monitoring cyklu klaczy",
        "Data inseminacji i dane ogiera",
        "Kontrola ciąży z badaniami USG",
        "Przewidywana data wyźrebienia i ostrzeżenia",
        "Miesięczny rozwój źrebięcia",
        "Rodowód i pochodzenie",
        "Notatki dla każdej klaczy",
        "Przegląd wszystkich ciężarnych klaczy",
      ],
      ctaLabel: "Zobacz moduł hodowlany",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niszowe rozwiązanie · stajnia i ujeżdżalnia",
      title: "Zarządzanie końmi dla wielu koni i stajni pensjonatowych.",
      lead: "Przy wielu koniach chodzi mniej o dane, a bardziej o komunikację. Każdy właściciel ma inne życzenia, rutyny, ustalenia żywieniowe i kwestie medyczne. Każdy pracownik musi mieć do nich dostęp bez zbędnego szukania.",
      cards: [
        {
          t: "Konie według właściciela",
          d: "Każdy właściciel widzi tylko swoje konie.",
        },
        {
          t: "Instrukcje pielęgnacji",
          d: "Widoczne dla stajni przy każdym koniu.",
        },
        {
          t: "Wspólny kalendarz",
          d: "Kowal, weterynarz i zawody w jednym widoku.",
        },
        {
          t: "Lista zadań",
          d: "Przydzielaj pracownikom z potwierdzeniem.",
        },
        {
          t: "Dostęp dla właściciela",
          d: "Klienci widzą swojego konia we własnej aplikacji.",
        },
        {
          t: "Kontakty alarmowe",
          d: "Zawsze pod ręką w sytuacjach stresowych w stajni.",
        },
      ],
      ctaLabel: "Zobacz moduł ujeżdżalni",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Od WhatsApp, Excel i tablicy do EquiSight.",
      lead: "Konkretnie: tak zmienia się Twoje codzienne zarządzanie końmi.",
      rows: [
        {
          before: "Grupy WhatsApp",
          after: "Uporządkowane notatki dla każdego konia",
        },
        {
          before: "Arkusze Excel",
          after: "Aktualne dossier konia z historią",
        },
        {
          before: "Tablica w stajni",
          after: "Wspólne planowanie w Twoim telefonie",
        },
        {
          before: "Luźne zdjęcia w aparacie",
          after: "Media powiązane z Twoim koniem",
        },
        {
          before: "Ustne ustalenia",
          after: "Zadania i przypomnienia z potwierdzeniem",
        },
        {
          before: "Zgubiony papierowy paszport",
          after: "Dokumenty zawsze pod ręką",
        },
      ],
    },
    helper: {
      title: "Która aplikacja do zarządzania końmi jest dla Ciebie?",
      lead: "Odpowiedz na 5 pytań i otrzymaj uczciwe zalecenie — nawet jeśli nie zawsze będzie nim EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Masz jednego konia czy kilka?",
          options: [
            {
              label: "Jeden koń",
              score: 1,
            },
            {
              label: "2–5 koni",
              score: 2,
            },
            {
              label: "Ponad 5 koni",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Zarządzasz końmi klientów lub osób trzecich?",
          options: [
            {
              label: "Nie, tylko moimi własnymi końmi",
              score: 0,
            },
            {
              label: "Czasami — dla rodziny lub znajomych",
              score: 1,
            },
            {
              label: "Tak, zawodowo (stajnia / ujeżdżalnia)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Czy chcesz śledzić hodowlę i ciążę?",
          options: [
            {
              label: "Nie dotyczy",
              score: 0,
            },
            {
              label: "Czasami — okazjonalna hodowla",
              score: 1,
            },
            {
              label: "Tak, jestem (lub zostaję) hodowcą",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Współpracujesz z trenerem, opiekunem lub profesjonalistą?",
          options: [
            {
              label: "Nie, robię wszystko sam",
              score: 0,
            },
            {
              label: "Tak, z jedną osobą",
              score: 1,
            },
            {
              label: "Tak, z wieloma osobami",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Czy chcesz tylko rejestrować, czy też uzyskiwać wgląd?",
          options: [
            {
              label: "Tylko rejestrować",
              score: 1,
            },
            {
              label: "Rejestrować i planować",
              score: 2,
            },
            {
              label: "Rejestrować, planować i analizować",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Prosty dziennik wystarczy — i rośnie razem z Tobą.",
          body: "Dla jednego konia bez wspólnej opieki każda aplikacja do zarządzania końmi jest odpowiednia. EquiSight zaczyna bezpłatnie od 1 konia, więc nie ryzykujesz nic. Jeśli później zechcesz dodać kolejne konie, trenera lub hodowlę — wszystko jest już w środku.",
          cta: "Zacznij bezpłatnie z 1 koniem",
        },
        mid: {
          title: "EquiSight dobrze pasuje do Twojej sytuacji.",
          body: "Masz wiele potrzeb (wiele koni, współpraca lub wgląd). Większość konkurentów pokrywa 1–2 moduły; EquiSight łączy je w jednej aplikacji, bez konieczności łączenia oddzielnych narzędzi.",
          cta: "Zobacz, co potrafi EquiSight",
        },
        high: {
          title: "EquiSight to najbardziej logiczny wybór.",
          body: "Twoja sytuacja łączy wiele koni, współpracę, hodowlę i/lub analizy. To właśnie tam EquiSight robi różnicę — żadnych rozproszonych narzędzi, tylko jedno dossier konia dla wszystkich i wszystkiego wokół niego.",
          cta: "Zacznij bezpłatnie z EquiSight",
        },
      },
    },
    faqTitle: "Najczęściej zadawane pytania o aplikacje do zarządzania końmi",
    faq: [
      {
        q: "Jaka jest najlepsza aplikacja do zarządzania końmi?",
        a: "Najlepsza aplikacja do zarządzania końmi zależy od Twojej sytuacji. Do prostego dziennika nadaje się wiele aplikacji. Jeśli chcesz połączyć zdrowie, trening, żywienie, dokumenty, hodowlę, planowanie i współpracę, EquiSight został zbudowany jako kompletne rozwiązanie, w którym wszystko trafia do jednego dossier.",
      },
      {
        q: "Czy mogę zarządzać wieloma końmi w jednej aplikacji?",
        a: "Tak. Dobra aplikacja do zarządzania końmi musi obsługiwać wiele koni, w tym właścicieli, opiekunów, rutyny, dokumenty, terminy i przypomnienia dla każdego konia z osobna. EquiSight został zaprojektowany z myślą o tym od pierwszej linii kodu — konie to indywidualne dossier, a nie wiersze na liście.",
      },
      {
        q: "Czy EquiSight nadaje się również dla hodowców?",
        a: "Tak. EquiSight można skonfigurować z funkcjami hodowlanymi, takimi jak cykl klaczy, data inseminacji, kontrola ciąży, dane ogiera, rodowód, przewidywana data wyźrebienia i rozwój źrebięcia. To właśnie obszar, w którym większość konkurencyjnych aplikacji nie oferuje lub oferuje bardzo mało.",
      },
      {
        q: "Czy mogę udostępniać dane mojemu trenerowi lub kowalowi?",
        a: "Tak. Celem EquiSight jest bezpieczne udostępnianie odpowiednich informacji osobom zaangażowanym w opiekę nad koniem — trenerowi, kowalowi, dentyście, weterynarzowi, fizjoterapeucie, opiekunowi lub właścicielowi. Każda osoba otrzymuje tylko te uprawnienia, które są niezbędne do jej roli.",
      },
      {
        q: "Dlaczego nie używać po prostu WhatsApp lub Excel?",
        a: "WhatsApp i Excel działają, dopóki sprawy pozostają proste. Gdy masz kilka koni, terminy, dokumenty, zabiegi, właścicieli lub dane hodowlane, ryzyko błędów rośnie: informacje się rozpraszają, szukanie zajmuje czas, a ustne ustalenia znikają. Aplikacja do zarządzania końmi zbiera wszystko w jednym miejscu dla każdego konia, z automatycznymi przypomnieniami.",
      },
      {
        q: "Ile kosztuje EquiSight?",
        a: "Możesz zacząć bezpłatnie z 1 koniem. Jeśli chcesz zarządzać wieloma końmi, aktywować hodowlę lub nadać dostęp profesjonalistom, dostępne są przystępne plany Premium. Sprawdź aktualne opcje na stronie z cennikiem.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Oprogramowanie hodowlane dla koni: pełne porównanie 2026",
      description: "Porównaj oprogramowanie hodowlane dla koni: cykl klaczy, ciąża, dobór ogiera i źrebięta. Odkryj, dlaczego EquiSight to kompletna aplikacja hodowlana.",
      keywords: [
        "oprogramowanie hodowlane dla koni",
        "aplikacja cyklu klaczy",
        "aplikacja ciąży klaczy",
        "aplikacja rejestracji źrebiąt",
        "aplikacja księgi stadnej koni",
        "planowanie krycia konia",
        "aplikacja doboru ogiera",
      ],
    },
    hero: {
      eyebrow: "Pomoc w wyborze · oprogramowanie hodowlane",
      breadcrumbLabel: "Oprogramowanie hodowlane",
      title: "Oprogramowanie hodowlane dla koni: pełne porównanie na 2026 rok.",
      intro: "Klacz hodowlana zasługuje na więcej niż zwykła aplikacja do zarządzania końmi. Porównaj funkcje hodowlane najpopularniejszych narzędzi, odkryj, na co naprawdę zwracać uwagę, i świadomie wybierz oprogramowanie dopasowane do Twojej stadniny — małej lub dużej.",
      pills: [
        {
          icon: "Baby",
          label: "Cykl klaczy",
        },
        {
          icon: "Heart",
          label: "Kontrola ciąży",
        },
        {
          icon: "Sparkles",
          label: "Rozwój źrebięcia",
        },
        {
          icon: "FileText",
          label: "Księga stadna",
        },
      ],
      ctas: [
        {
          label: "Rozpocznij bezpłatnie z modułem hodowlanym",
          href: "#start",
          primary: true,
        },
        {
          label: "Przejdź do tabeli porównawczej",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Dlaczego zwykła aplikacja do zarządzania końmi nie wystarczy do hodowli.",
      lead: "Większość aplikacji jeździeckich jest zaprojektowana dla jednego konia sportowego lub rekreacyjnego. Hodowla ma zupełnie inny rytm: rujność, inseminacja, kontrola ciąży, badania USG, kalendarz źrebień, rodowód i sprzedaż. Jeden arkusz Excel po 2 sezonach przestaje działać — a przy kilku klaczach tracisz kontrolę.",
      items: [
        "Kiedy była ostatnia rujność Bonity?",
        "Który ogier jest zaplanowany do krycia w przyszłym sezonie?",
        "Czy badanie USG po 21 dniach jest już zaplanowane?",
        "Które źrebięta z 2024 roku zostały już sprzedane?",
        "Gdzie jest diagram rodowodu sięgający dziadka ze strony matki?",
        "Gdzie są próbki DNA i dane paszportowe?",
      ],
    },
    what: {
      title: "Czym jest oprogramowanie hodowlane dla koni?",
      lead: "Oprogramowanie hodowlane to specjalistyczna kartoteka dla każdej klaczy i ogiera, połączona z kalendarzem roku hodowlanego, planowaniem ciąży, rejestracją źrebiąt i podglądem rodowodu. Nie zwykły dziennik konia, lecz narzędzie rozumiejące cykl hodowlany: od pierwszej rujności aż po odsadzenie.",
      targetGroupsTitle: "Dla jakiego typu hodowcy przeznaczone jest oprogramowanie hodowlane?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hodowca amator (1–3 klacze)",
          body: "Jedno lub dwa krycia rocznie — przejrzystość bez żonglowania arkuszami Excel.",
        },
        {
          icon: "Building2",
          title: "Mała stadnina (4–10 klaczy)",
          body: "Plan roku hodowlanego z cyklem, inseminacją, kontrolami ciąży i kartoteką źrebięcia.",
        },
        {
          icon: "Users",
          title: "Profesjonalna stadnina (10+)",
          body: "Wielu pracowników, dobór ogiera do każdej klaczy, sprzedaż i marketing.",
        },
        {
          icon: "Target",
          title: "Właściciel ogiera",
          body: "Historia zamówień, statystyki nasienia i kalendarz dla każdego ogiera.",
        },
        {
          icon: "Heart",
          title: "Transplantacja embrionów",
          body: "Dawczyni i biorczyni jako połączone kartoteki, kalendarz ET.",
        },
        {
          icon: "ClipboardList",
          title: "Rejestracja w księdze stadnej",
          body: "Próbki DNA, dokumenty paszportowe i dane rodowodowe.",
        },
      ],
    },
    criteria: {
      title: "Czego wymaga dobre oprogramowanie hodowlane?",
      lead: "Nie każda \"funkcja hodowlana\" w aplikacji dla koni jest taka sama. Pięć kluczowych obszarów, w których hodowcy tracą dużo czasu — i gdzie oprogramowanie naprawdę robi różnicę.",
      items: [
        {
          icon: "Calendar",
          title: "Cykl klaczy i rujność",
          body: "Codzienny dziennik, przewidywanie owulacji, rolowanie cyklu i automatyczne przypomnienia.",
        },
        {
          icon: "Heart",
          title: "Inseminacja i kontrola ciąży",
          body: "Daty krycia i inseminacji, dane ogiera, badanie USG po 14, 21, 60 dniach i określenie płci.",
        },
        {
          icon: "Baby",
          title: "Rozwój źrebięcia",
          body: "Dane urodzeniowe, wykres masy ciała, harmonogram odrobaczania, moment odsadzenia, rejestracja paszportu.",
        },
        {
          icon: "FileText",
          title: "Rodowód i dokumenty",
          body: "Podgląd rodowodu do 4–5 pokoleń, DNA, numery paszportów i status w księdze stadnej.",
        },
        {
          icon: "Target",
          title: "Dobór ogiera i kojarzenie",
          body: "Filtrowanie według dyscypliny, linii, danych ogiera i historycznych wyników — nie tylko to, co promuje właściciel ogiera.",
        },
        {
          icon: "Share2",
          title: "Współpraca z weterynarzem/inseminatorem",
          body: "Wyniki USG, próbki i statusy udostępniane bezpośrednio gabinетowi pracującemu z Twoimi klaczami.",
        },
      ],
    },
    comparison: {
      title: "EquiSight a inne oprogramowanie hodowlane.",
      lead: "Polskie wyniki wyszukiwania dla oprogramowania hodowlanego często pokazują ogólne aplikacje dla koni, które wzmiankują hodowlę jednym zdaniem. Uczciwie porównujemy, które narzędzia naprawdę oferują kompletny przepływ pracy hodowlanej.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Bezpłatny start",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Rejestrowanie cyklu klaczy",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Data inseminacji + ogier",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "USG i kontrola ciąży",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Przewidywana data źrebienia",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Kartoteka źrebięcia (waga/wzrost)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rodowód do 4–5 pokoleń",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Rejestracja DNA i paszportu",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Dobór ogiera / kojarzenie",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / transplantacja embrionów",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Przegląd wielu klaczy",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilna (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Udostępnianie weterynarzowi",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Zintegrowana z ogólną kartoteką",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sprzedaż i marketing źrebiąt",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Porównanie na podstawie publicznie dostępnych funkcji w styczniu 2026. EquineGenie jest silny w hodowli, ale słabszy pod względem aplikacji mobilnej i ogólnego zarządzania końmi. EquiSight łączy obie funkcje.",
    },
    why: {
      title: "Dlaczego EquiSight obsługuje hodowców inaczej.",
      lead: "Wielu hodowców korzysta z osobnego oprogramowania hodowlanego i oddzielnej aplikacji do zarządzania końmi. EquiSight łączy obie — bez przełączania się między aplikacjami i bez dwukrotnego wprowadzania danych.",
      points: [
        {
          icon: "Heart",
          title: "Klacz hodowlana pozostaje zwykłym koniem",
          body: "Klacz hodowlana ma zarówno kartotekę hodowlaną, jak i zwykłą kartotekę konia — zdrowie, szczepienia, kowal. Jedna aplikacja, wszystkie moduły.",
        },
        {
          icon: "Sparkles",
          title: "Prewencyjnie, nie reaktywnie",
          body: "Prognozowanie cyklu, przypomnienia o kamieniach milowych ciąży i kalendarz źrebień — automatycznie na podstawie Twoich danych.",
        },
        {
          icon: "Share2",
          title: "Wszyscy wokół hodowli",
          body: "Inseminator, właściciel ogiera, weterynarz, kupujący, księga stadna — wszyscy mają dostęp z odpowiednimi uprawnieniami.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Według dyscypliny · od cyklu do odsadzenia",
      title: "Co zawiera kartoteka hodowlana w EquiSight.",
      lead: "Każda klacz otrzymuje kompletną kartotekę hodowlaną, powiązaną z jej regularną kartoteką konia.",
      items: [
        "Codzienny dziennik cyklu z prognozą",
        "Inseminacja/krycie + dane ogiera",
        "Harmonogram USG (14/21/60 dni + płeć)",
        "Kamienie milowe ciąży z automatycznymi przypomnieniami",
        "Przewidywana data źrebienia i przygotowania",
        "Kartoteka źrebięcia od urodzenia",
        "Rodowód do dziadków/babć z nawigacją klikania",
        "Próbka DNA, paszport, status w księdze stadnej",
        "Lejek sprzedaży z listą zainteresowanych",
        "Historia doboru ogiera dla każdej klaczy",
      ],
      ctaLabel: "Zobacz moduł hodowlany",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Dla całej stadniny",
      title: "Przegląd wielu klaczy i ogierów.",
      lead: "Gdy hodujesz więcej niż 2–3 klacze, przegląd wszystkich cykli i ciąż staje się kluczowy.",
      cards: [
        {
          t: "Panel cyklu",
          d: "Wszystkie klacze obok siebie, z etapem cyklu i kolejnym działaniem.",
        },
        {
          t: "Lejek ciąży",
          d: "Które klacze są na którym etapie kamieni milowych ciąży?",
        },
        {
          t: "Kalendarz źrebień",
          d: "Oczekiwane porody według miesiąca, z dopasowaną logistyką.",
        },
        {
          t: "Portfolio ogierów",
          d: "Własne ogiery lub stali inseminatorzy z historią zamówień.",
        },
        {
          t: "Wykres rodowodu",
          d: "Analiza przodków przez wiele pokoleń i linii.",
        },
        {
          t: "Panel sprzedaży",
          d: "Które źrebięta są sprzedane, zarezerwowane lub nadal dostępne.",
        },
      ],
    },
    beforeAfter: {
      title: "Od Excela i kalendarza do EquiSight hodowla.",
      lead: "Konkretnie: tak zmienia się Twój sezon hodowlany.",
      rows: [
        {
          before: "Cykl w luźnych notatkach",
          after: "Codzienny dziennik z prognozą",
        },
        {
          before: "Wyniki USG przez WhatsApp do inseminatora",
          after: "Wspólna kartoteka ze zdjęciami",
        },
        {
          before: "Data ciąży w kalendarzu",
          after: "Automatyczne przypomnienia o kamieniach milowych",
        },
        {
          before: "Paszport źrebięcia w szufladzie",
          after: "Dokument powiązany z profilem źrebięcia",
        },
        {
          before: "Rodowód na papierze",
          after: "Klikalny rodowód do 4–5 pokoleń",
        },
        {
          before: "Ogłoszenie sprzedaży na Marktplaats",
          after: "Lejek sprzedaży z listą zainteresowanych",
        },
      ],
    },
    helper: {
      title: "Które oprogramowanie hodowlane jest dla Ciebie odpowiednie?",
      lead: "5 pytań, aby sprawdzić, czy potrzebujesz kompletnej aplikacji hodowlanej, czy wystarczy narzędzie dla hobbystów.",
      questions: [
        {
          id: "mares",
          q: "Ile klaczy hodowlanych prowadzisz?",
          options: [
            {
              label: "1 klacz",
              score: 1,
            },
            {
              label: "2–5 klaczy",
              score: 2,
            },
            {
              label: "Więcej niż 5 klaczy",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Jak często hodujesz w ciągu roku?",
          options: [
            {
              label: "Sporadycznie (co kilka lat)",
              score: 0,
            },
            {
              label: "Co roku 1–2 krycia",
              score: 2,
            },
            {
              label: "Co roku 3+ krycia",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Jak przeprowadzasz inseminację/krycie?",
          options: [
            {
              label: "Krycie naturalne",
              score: 1,
            },
            {
              label: "AI świeżym/schłodzonym nasieniem",
              score: 2,
            },
            {
              label: "ET lub nasienie mrożone",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Czy współpracujesz z weterynarzem/inseminatorem?",
          options: [
            {
              label: "Jedna stała osoba",
              score: 1,
            },
            {
              label: "Kilka gabinetów",
              score: 2,
            },
            {
              label: "Sieć międzynarodowa",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Co teraz rejestrujesz?",
          options: [
            {
              label: "Excel lub papier",
              score: 1,
            },
            {
              label: "Ogólna aplikacja do zarządzania końmi",
              score: 2,
            },
            {
              label: "Nic w sposób ustrukturyzowany",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Narzędzie dla hobbystów lub Excel wystarczy — ale EquiSight i tak się przyda.",
          body: "Przy 1 klaczy z naturalnym kryciem co kilka lat rozbudowany moduł hodowlany to przesada. EquiSight startuje bezpłatnie, a moduł hodowlany aktywujesz tylko na rok, w którym kryjesz — bez obowiązku uaktualniania.",
          cta: "Rozpocznij bezpłatnie",
        },
        mid: {
          title: "EquiSight hodowla to właściwe narzędzie.",
          body: "Masz kilka klaczy lub kilka metod hodowlanych — do tego ogólne aplikacje dla koni nie są przystosowane. EquiSight łączy hodowlę i ogólną opiekę, więc nie przełączasz się między dwoma narzędziami.",
          cta: "Zobacz moduł hodowlany",
        },
        high: {
          title: "EquiSight został stworzony dla Twojej stadniny.",
          body: "Wiele klaczy, ET lub nasienie mrożone, międzynarodowy zespół — większość narzędzi tu zawodzi. EquiSight skaluje się do poziomu stadniny bez konieczności kumulowania dodatkowych licencji.",
          cta: "Porozmawiaj z nami o planie Stadnina",
        },
      },
    },
    faqTitle: "Najczęściej zadawane pytania dotyczące oprogramowania hodowlanego",
    faq: [
      {
        q: "Jakie jest najlepsze oprogramowanie hodowlane dla koni?",
        a: "Przy 1 klaczy bez skomplikowanej metody hodowlanej wiele narzędzi jest wystarczających. Od 2–3 klaczy, przy stosowaniu AI lub ET albo współpracy z weterynarzem i księgą stadną, kompletny moduł hodowlany staje się kluczowy. EquiSight łączy hodowlę z ogólnym zarządzaniem końmi w jednej aplikacji, więc nie musisz się przełączać.",
      },
      {
        q: "Jakich funkcji hodowlanych naprawdę potrzebuję?",
        a: "Minimum: dziennik cyklu, dane inseminacji/krycia, kamienie milowe kontroli ciąży i kartoteka źrebięcia. Opcjonalnie, ale bardzo przydatne: podgląd rodowodu, archiwum doboru ogiera, DNA/paszport i lejek sprzedaży.",
      },
      {
        q: "Czy EquiSight potrafi przewidywać cykl klaczy?",
        a: "Tak. EquiSight wykorzystuje wcześniejsze dane cyklu, aby wyświetlić prognozowaną owulację, dzięki czemu planujesz inseminację lub krycie we właściwym momencie — bez codziennego zgadywania.",
      },
      {
        q: "Czy EquiSight działa również przy transplantacji embrionów?",
        a: "Tak. Dawczyni i biorczyni otrzymują połączone kartoteki, kalendarz ET i wspólne kamienie milowe z gabinetem. Dzięki temu nie gubisz harmonogramu w skomplikowanym procesie ET.",
      },
      {
        q: "Czy mogę zaimportować istniejące dane hodowlane?",
        a: "Możesz wprowadzić dane cyklu, krycia i źrebiąt ręcznie lub zbiorczo przez CSV. W przypadku aktywnych hodowli pomagamy przy jednorazowej migracji, jeśli masz dane z kilku sezonów.",
      },
      {
        q: "Jak udostępnić kartotekę weterynarzowi lub inseminatorowi?",
        a: "Każda osoba otrzymuje dostęp z przypisaną rolą: weterynarz, inseminator, właściciel ogiera lub urzędnik księgi stadnej. Każdy widzi tylko informacje niezbędne do swojej roli — pełny dostęp nie jest wymagany.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Oprogramowanie dla stajni: pełne porównanie i pomoc w wyborze 2026",
      description: "Porównaj oprogramowanie dla stajni do zarządzania lekcjami, jeźdźcami, końmi i administracją. Odkryj, która aplikacja pasuje do Twojej stajni lub pensjonatu.",
      keywords: [
        "oprogramowanie dla stajni",
        "aplikacja do zarządzania stajnią",
        "oprogramowanie administracyjne stajni",
        "planowanie lekcji stajnia",
        "oprogramowanie pensjonat dla koni",
        "administracja jeźdźców",
        "administracja koni stajnia",
      ],
    },
    hero: {
      eyebrow: "Pomoc w wyborze · oprogramowanie dla stajni",
      breadcrumbLabel: "Oprogramowanie dla stajni",
      title: "Oprogramowanie dla stajni: pełny przewodnik po wyborze dla stajni i pensjonatów.",
      intro: "Planowanie lekcji, administracja jeźdźców, zarządzanie końmi, fakturowanie i komunikacja — dobre oprogramowanie dla stajni łączy to wszystko w jedno. Porównaj najpopularniejsze opcje i odkryj, która pasuje do Twojej stajni.",
      pills: [
        {
          icon: "Calendar",
          label: "Planowanie lekcji",
        },
        {
          icon: "Users",
          label: "Jeźdźcy i klienci",
        },
        {
          icon: "Heart",
          label: "Opieka nad końmi",
        },
        {
          icon: "CreditCard",
          label: "Fakturowanie",
        },
      ],
      ctas: [
        {
          label: "Umów demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Do tabeli porównawczej",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Dlaczego rozproszone narzędzia spowalniają stajnię.",
      lead: "Większość stajni działa na łataninie: planowanie lekcji na tablicy, rejestracja jeźdźców w Excel, fakturowanie w osobnym narzędziu, opieka nad końmi przez WhatsApp, a kontakt z właścicielami przez prywatne wiadomości. W ruchliwym tygodniu pojawiają się podwójne rezerwacje, zapomniane faktury lub konie, które nie wiedzą, którego jeźdźca mają dostać.",
      items: [
        "Kto teraz ma lekcję na Jaśminie?",
        "Który jeździec nie zapłacił jeszcze za marzec?",
        "Który koń nie może być używany w tym tygodniu?",
        "Kto jest kontaktem alarmowym uczniów?",
        "Czy właściciel Stardusta otrzymał już fakturę od kowala?",
        "Który koń stoi w którym boksie?",
      ],
    },
    what: {
      title: "Czym jest oprogramowanie dla stajni?",
      lead: "Oprogramowanie dla stajni łączy planowanie lekcji, administrację jeźdźców, zarządzanie końmi, fakturowanie i komunikację w jednym narzędziu. Koniec z akrobacją w Excel i spaghetti z WhatsApp — jedno miejsce, gdzie stajnia działa, a właściciele i jeźdźcy mają wgląd.",
      targetGroupsTitle: "Dla jakiego typu firm jest przeznaczone oprogramowanie dla stajni?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Mała stajnia (1–15 koni)",
          body: "Przede wszystkim planowanie lekcji i płatności — administracja bez bólu głowy.",
        },
        {
          icon: "Users",
          title: "Średnia stajnia (15–40 koni)",
          body: "Wielu instruktorów, planowanie lekcji + harmonogram koni + administracja jeźdźców.",
        },
        {
          icon: "ClipboardList",
          title: "Duża stajnia jeździecka i pensjonat (40+)",
          body: "Pełna operacja obejmująca fakturowanie, planowanie pasz i kowalstwa.",
        },
        {
          icon: "Heart",
          title: "Pensjonat dla koni",
          body: "Portal właściciela, indywidualne instrukcje opieki, wspólny kalendarz.",
        },
        {
          icon: "Target",
          title: "Stajnia treningowa — skoki",
          body: "Planowanie zawodów, trening dla każdego konia, kontakt z klientem.",
        },
        {
          icon: "FileText",
          title: "Przedsiębiorcy hippiczni",
          body: "Mix lekcji + pensjonat + kliniki + handel — wszystko z jednego systemu.",
        },
      ],
    },
    criteria: {
      title: "Jakie wymagania powinno spełniać dobre oprogramowanie dla stajni?",
      lead: "Ładna aplikacja nic nie znaczy, jeśli pracownicy nie chcą z niej korzystać. Pięć praktycznych kryteriów decydujących o różnicy między sukcesem a frustracją.",
      items: [
        {
          icon: "Calendar",
          title: "Planowanie lekcji na wielu poziomach",
          body: "Początkujący/zaawansowani, ujeżdżenie/skoki, przypisania koni i kalendarze instruktorów — wszystko widoczne obok siebie.",
        },
        {
          icon: "Users",
          title: "Administracja jeźdźców",
          body: "Profile, poziom, abonament, karnet lekcyjny i powiązania rodzinne dla młodych jeźdźców.",
        },
        {
          icon: "Heart",
          title: "Harmonogram koni",
          body: "Jak często dany koń jest używany, z uwzględnieniem okresów odpoczynku, kontuzji i rehabilitacji.",
        },
        {
          icon: "CreditCard",
          title: "Fakturowanie i abonamenty",
          body: "Miesięczne abonamenty, karnety lekcyjne, pojedyncze lekcje i automatyczne polecenia zapłaty.",
        },
        {
          icon: "Share2",
          title: "Portal właściciela (pensjonat)",
          body: "Właściciele widzą swojego konia we własnej aplikacji — kalendarz, koszty, kowal i notatki bez dzwonienia.",
        },
        {
          icon: "Bell",
          title: "Komunikacja i przypomnienia",
          body: "Automatyczne przypomnienia o lekcjach, powiadomienia o płatnościach, ogłoszenia od kowala — bez pisania na messengerze.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs inne oprogramowanie dla stajni.",
      lead: "Wiele narzędzi dla stajni jest silnych w planowaniu lekcji lub fakturowaniu, ale rzadko jednocześnie w opiece nad końmi i komunikacji z właścicielami. Zestawiamy je ze sobą uczciwie.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Darmowy start / okres próbny",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Planowanie lekcji",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Wielu instruktorów",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administracja jeźdźców",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Harmonogram koni",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Opieka nad końmi (szczepienia/kowal)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Karnet / abonament",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Płatności online",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatyczne fakturowanie",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal właściciela (pensjonat)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integracja z kowalem/weterynarzem",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Przypomnienia WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilna (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Planowanie zawodów",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Odpowiednie dla pensjonatu",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Porównanie na podstawie publicznie dostępnych funkcji według stanu na styczeń 2026. Stalmanager wyróżnia się w administracji, EquiSight wyróżnia się przepływem pracy pensjonatu + opieką nad końmi + portalem właściciela.",
    },
    why: {
      title: "Dlaczego EquiSight jest inny dla stajni i pensjonatów.",
      lead: "EquiSight wykracza poza zwykły planer lekcji. Postrzegamy stajnię jako kompletną operację: konie, ludzie, komunikacja i finanse — wszystko wzajemnie od siebie zależne.",
      points: [
        {
          icon: "Heart",
          title: "Koń w centrum, nie kalendarz",
          body: "Każdy koń ma własną dokumentację. Użycie na lekcjach, zdrowie, kowal i zawody w jednej osi czasu — a nie 3 osobne narzędzia.",
        },
        {
          icon: "Share2",
          title: "Właściciele mają wgląd bez dzwonienia",
          body: "Właściciele koni w pensjonacie mają własny widok: koszty, planowanie, zdjęcia i notatki — oszczędza to 5–10 telefonów tygodniowo.",
        },
        {
          icon: "Bell",
          title: "Automatyczna komunikacja",
          body: "Przypomnienie o lekcji, przypomnienie o szczepieniu, faktura — automatycznie, przez aplikację/e-mail/SMS. Koniec z grupowymi wiadomościami na WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Dla pensjonatu",
      title: "Co EquiSight oferuje pensjonatowi.",
      lead: "Pensjonaty mają unikalne wyzwania, których zwykłe oprogramowanie dla stajni nie rozwiązuje.",
      cards: [
        {
          t: "Portal właściciela",
          d: "Każdy właściciel widzi tylko swoje konie, kalendarz i koszty.",
        },
        {
          t: "Instrukcje opieki dla każdego konia",
          d: "Pasza, siano, suplementy, harmonogram derki — widoczne dla obsługi stajni.",
        },
        {
          t: "Wspólny kalendarz",
          d: "Kowal, weterynarz i wizyty właściciela w jednym widoku.",
        },
        {
          t: "Koszty zużycia na konia",
          d: "Ściółka, pasza, koncentraty rozliczane na każdego właściciela.",
        },
        {
          t: "Kontakty alarmowe dla konia",
          d: "Właściciel, weterynarz i kowal zawsze dostępni dla obsługi stajni.",
        },
        {
          t: "Zarządzanie wypasem",
          d: "Które konie idą na pastwisko, odpoczywają lub są w rehabilitacji?",
        },
      ],
    },
    beforeAfter: {
      title: "Od tablicy i Excel do EquiSight.",
      lead: "Konkretnie: tak zmienia się tydzień pracy w stajni.",
      rows: [
        {
          before: "Tablica z planem lekcji",
          after: "Plan na żywo dla każdego instruktora",
        },
        {
          before: "Excel z jeźdźcami i notatkami z lekcji",
          after: "CRM klientów z historią lekcji",
        },
        {
          before: "WhatsApp do właścicieli",
          after: "Portal właściciela dla jego konia",
        },
        {
          before: "Ręczne miesięczne polecenie zapłaty",
          after: "Automatyczne fakturowanie + iDEAL",
        },
        {
          before: "Opieka nad końmi na tablicy korkowej",
          after: "Instrukcje opieki dla każdego konia, współdzielone",
        },
        {
          before: "Ustna umowa z kowalem",
          after: "Planowanie kowala z potwierdzeniami",
        },
      ],
    },
    helper: {
      title: "Które oprogramowanie dla stajni pasuje do Ciebie?",
      lead: "5 pytań, aby sprawdzić, czy EquiSight to odpowiednia platforma dla Twojej stajni lub pensjonatu.",
      questions: [
        {
          id: "size",
          q: "Ile koni masz w swoim obiekcie?",
          options: [
            {
              label: "Mniej niż 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Ponad 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Jaka jest Twoja główna działalność?",
          options: [
            {
              label: "Przede wszystkim prowadzenie lekcji",
              score: 1,
            },
            {
              label: "Pensjonat dla koni",
              score: 3,
            },
            {
              label: "Mix lekcji i pensjonatu",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Ilu instruktorów z Tobą pracuje?",
          options: [
            {
              label: "Tylko ja",
              score: 1,
            },
            {
              label: "2–3 instruktorów",
              score: 2,
            },
            {
              label: "4 lub więcej",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Jak teraz obsługujesz fakturowanie?",
          options: [
            {
              label: "Ręcznie (Word/Excel)",
              score: 3,
            },
            {
              label: "Osobny program księgowy",
              score: 2,
            },
            {
              label: "Zintegrowane z narzędziem do lekcji",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Jak komunikujesz się z właścicielami koni?",
          options: [
            {
              label: "Osobiście / WhatsApp",
              score: 3,
            },
            {
              label: "E-mail + WhatsApp",
              score: 2,
            },
            {
              label: "Portal właściciela w narzędziu",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Lekkie narzędzie lub Excel na razie wystarczy — ale EquiSight rośnie razem z Tobą.",
          body: "Dla małej stajni z jednym instruktorem i niewielkim pensjonatem rozbudowany pakiet nie jest od razu potrzebny. EquiSight startuje bezpłatnie i rośnie razem z Twoją stajnią — bez bólu migracji za kilka lat.",
          cta: "Zacznij bezpłatnie",
        },
        mid: {
          title: "EquiSight to logiczne ulepszenie dla Twojej stajni.",
          body: "Wielu instruktorów, mix lekcji i pensjonatu lub fakturowanie oddzielone od reszty — EquiSight łączy to wszystko w jeden przepływ pracy. Szczególnie portal właściciela znacznie ogranicza komunikację ad hoc.",
          cta: "Umów demo",
        },
        high: {
          title: "EquiSight jest stworzony na Twoją skalę.",
          body: "Pensjonat + lekcje + wielu instruktorów to dokładnie to, w czym EquiSight wyróżnia się na tle klasycznych narzędzi dla stajni. Portal właściciela i integracja opieki nad końmi oszczędzają co tydzień wiele godzin administracji i komunikacji.",
          cta: "Zaplanuj demo dla swojej stajni",
        },
      },
    },
    faqTitle: "Najczęściej zadawane pytania dotyczące oprogramowania dla stajni",
    faq: [
      {
        q: "Jakie jest najlepsze oprogramowanie dla stajni?",
        a: "Do samego planowania lekcji istnieje kilka dobrych opcji. Gdy tylko potrzebujesz pensjonatu, wielu instruktorów lub śledzenia opieki nad końmi, EquiSight staje się kompletnym rozwiązaniem — bez żonglowania narzędziami, wszystko w jednym miejscu.",
      },
      {
        q: "Czy mogę zaimportować istniejących klientów i lekcje?",
        a: "Tak. Dane klientów i harmonogramy lekcji można importować przez CSV. Pomagamy aktywnym stajniom w jednorazowej migracji, żebyś nie musiał ręcznie wprowadzać 200 jeźdźców.",
      },
      {
        q: "Czy działa też dla pensjonatu bez lekcji?",
        a: "Tak. Tryb pensjonatu wyłącza lekcje i koncentruje się na portalu właściciela, paszy/opiece, planowaniu kowala i rozliczaniu kosztów na konia.",
      },
      {
        q: "Czy jeźdźcy mogą sami się zapisywać i płacić?",
        a: "Tak. Jeźdźcy mogą przez własne konto sprawdzić dostępne lekcje, zapisać się, zapłacić czesne przez iDEAL i kupować karnety lekcyjne.",
      },
      {
        q: "Jak wygląda kwestia prywatności danych koni i właścicieli?",
        a: "Każda osoba ma przypisaną rolę (właściciel, jeździec, instruktor, pracownik). W zależności od roli widzi się tylko to, co jest potrzebne. Właściciele widzą tylko swojego konia, jeźdźcy tylko własne lekcje.",
      },
      {
        q: "Czy EquiSight można połączyć z moim oprogramowaniem księgowym?",
        a: "Tak, dostępne są integracje z Exact, Moneybird i e-Boekhouden. Faktury są wtedy automatycznie przekazywane do Twojej księgowości.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Aplikacja treningowa dla koni: porównanie i poradnik wyboru dla trenerów 2026",
      description: "Porównaj aplikacje treningowe dla koni i jeźdźców: dziennik treningowy, wideo, cele, analiza protokołów i zarządzanie klientami. Znajdź odpowiednie narzędzie dla trenerów.",
      keywords: [
        "aplikacja treningowa dla koni",
        "aplikacja dla instruktora",
        "aplikacja do treningu koni",
        "aplikacja do coachingu jeźdźców",
        "dziennik treningowy konia",
        "analiza protokołu ujeżdżenia",
        "oprogramowanie dla trenera koni",
      ],
    },
    hero: {
      eyebrow: "Poradnik wyboru · oprogramowanie dla trenerów",
      breadcrumbLabel: "Aplikacja treningowa",
      title: "Aplikacja treningowa dla koni: kompletny poradnik wyboru dla instruktorów i trenerów.",
      intro: "Trener lub instruktor żongluje parami, lekcjami, filmami, celami i zawodami. Porównaj najlepsze aplikacje treningowe dla miłośników koni i wybierz platformę, która będzie rosła razem z Twoim coachingiem również w 2026 roku.",
      pills: [
        {
          icon: "Target",
          label: "Cele i planowanie",
        },
        {
          icon: "Video",
          label: "Analiza wideo",
        },
        {
          icon: "TrendingUp",
          label: "Postępy",
        },
        {
          icon: "Users",
          label: "Klienci/pary",
        },
      ],
      ctas: [
        {
          label: "Zacznij bezpłatnie jako trener",
          href: "#start",
          primary: true,
        },
        {
          label: "Przejdź do tabeli porównawczej",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Dlaczego coaching przez WhatsApp przeszkadza trenerom.",
      lead: "Większość trenerów korzysta z oddzielnych narzędzi: WhatsApp do komunikacji, notatnik do lekcji, YouTube lub WeTransfer do filmów i Excel do wyników zawodów. Przy 5 jeźdźcach to działa. Przy 20 jeźdźcach informacje się gubią, zapominasz o celach i tracisz kontrolę nad indywidualnym postępem.",
      items: [
        "Jaki jest cel Anouk na ten sezon?",
        "Jaki film wysłałem w zeszłym miesiącu do Brama?",
        "Czy Lara widziała analizę protokołu z ostatnich zawodów?",
        "Która para trenuje ile razy w tygodniu?",
        "Czy właściciel Stardusta przeczytał moje instrukcje treningowe?",
        "Kiedy ostatnio dawałem informację zwrotną na temat wahającego się impuls?",
      ],
    },
    what: {
      title: "Czym jest aplikacja treningowa dla koni i jeźdźców?",
      lead: "Aplikacja treningowa łączy CRM coachingowy (pary, lekcje, cele), dziennik treningowy dla każdego konia, informacje zwrotne wideo, planowanie zawodów i analizę protokołów. Koniec z oddzielnymi narzędziami jak WhatsApp/YouTube/Excel — jedna platforma, na której trener i jeździec pracują razem.",
      targetGroupsTitle: "Dla jakiego typu trenera jest to przeznaczone?",
      targetGroups: [
        {
          icon: "Target",
          title: "Instruktor ujeżdżenia",
          body: "Skanowanie protokołów, łączenie komentarzy sędziów z celami treningowymi, śledzenie postępów.",
        },
        {
          icon: "Activity",
          title: "Trener skoków",
          body: "Planowanie tras, informacje zwrotne po rundzie, zarządzanie wysokością przeszkód dla każdego konia.",
        },
        {
          icon: "Award",
          title: "Trener wszechstronnego kwalifikowanego (WKKW)",
          body: "Trzy dyscypliny, trzy plany — wszystkie widoczne obok siebie.",
        },
        {
          icon: "TrendingUp",
          title: "Trener wydajności (sport)",
          body: "Śledzenie EPI, zawody, cele — dla sportowców wyczynowych i ich zespołów.",
        },
        {
          icon: "Users",
          title: "Instruktor w stajni",
          body: "Lekcje grupowe i indywidualny coaching w jednej aplikacji.",
        },
        {
          icon: "Heart",
          title: "Trener rekreacyjny",
          body: "Hipoterapia, początkujący, właściciele jednego konia.",
        },
      ],
    },
    criteria: {
      title: "Czego wymaga dobra aplikacja treningowa?",
      lead: "Trening to praca z ludźmi, ale odpowiednie narzędzie sprawia, że jesteś o 30–50% bardziej efektywny i pomaga jeźdźcom rozwijać się również między lekcjami.",
      items: [
        {
          icon: "Users",
          title: "Zarządzanie parami",
          body: "Koń i jeździec jako jedna jednostka, z poziomem, celami, postępami i historią.",
        },
        {
          icon: "ClipboardList",
          title: "Notatki z lekcji i cele",
          body: "Notatka z każdej lekcji z punktami skupienia, powiązana z celami długoterminowymi.",
        },
        {
          icon: "Video",
          title: "Informacje zwrotne wideo",
          body: "Prześlij film, oznacz momenty, dodaj mówione lub pisemne komentarze.",
        },
        {
          icon: "Target",
          title: "Analiza zawodów i protokołów",
          body: "Skanuj protokoły (KNHS/FEI), przeglądaj wyniki dla poszczególnych elementów, komentarze sędziów i trendy.",
        },
        {
          icon: "Calendar",
          title: "Planowanie i karnety lekcji",
          body: "Kalendarz, płatności, subskrypcje i automatyczne przypomnienia.",
        },
        {
          icon: "Share2",
          title: "Komunikacja z jeźdźcem",
          body: "Jeździec widzi własną stronę z lekcjami, filmami, celami i informacjami zwrotnymi.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs inne aplikacje dla trenerów.",
      lead: "Niektóre narzędzia dla trenerów skupiają się na zastąpieniu WhatsApp, inne na analizie protokołów. EquiSight łączy obie funkcje z prawdziwą dokumentacją konia — dzięki czemu jeździec rozwija się również między lekcjami.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Bezpłatny start",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Zarządzanie parami",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Notatki z lekcji i informacje zwrotne",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Cele długoterminowe",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Przesyłanie wideo i informacje zwrotne",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Skanowanie protokołów KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Indeks Wydajności)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalendarz zawodów",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal jeźdźca",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Karnet lekcji / subskrypcja",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Płatności online",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Zintegrowana dokumentacja konia",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Widoczny korektor kopyt/weterynarz",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Dla instruktora I jeźdźca",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Wiele koni na jednego jeźdźca",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Porównanie na podstawie publicznie dostępnych funkcji w styczniu 2026. EquiSight jako jedyny łączy analizę protokołów i EPI z ogólnym zarządzaniem koniem.",
    },
    why: {
      title: "Dlaczego EquiSight oferuje inne doświadczenie treningowe.",
      lead: "Większość narzędzi dla trenerów kończy się tam, gdzie kończy się lekcja. EquiSight działa dalej — w dokumentacji konia, analizie zawodów, współpracy z weterynarzem i właścicielem.",
      points: [
        {
          icon: "TrendingUp",
          title: "Skan protokołu → cel treningowy",
          body: "Zeskanuj protokół KNHS i od razu zobacz, które elementy wymagają uwagi. Cele pojawiają się automatycznie.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach wzmacnia Twoje oko",
          body: "Dane z wielu lekcji, zawodów i protokołów ujawniają wzorce, których nie jesteś w stanie zapamiętać.",
        },
        {
          icon: "Share2",
          title: "Zintegrowany z koniem",
          body: "Trener widzi historię szczepień, korektora kopyt i kontuzji konia — żadnego planowania treningu w trakcie rekonwalescencji.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Dla ujeżdżenia i skoków",
      title: "Co zawiera dokumentacja coachingowa w EquiSight.",
      lead: "Dla każdej pary otrzymujesz strumień coachingowy, który zbiera wszystko razem — koniec z gubionymi informacjami w WhatsApp.",
      items: [
        "Notatki z lekcji z punktami skupienia dla każdej sesji",
        "Cele długoterminowe i kamienie milowe",
        "Przesyłanie wideo z komentarzami do znacznika czasu",
        "Skan protokołu KNHS/FEI z wynikami",
        "Komentarze sędziów powiązane z treningiem",
        "Wyniki zawodów i trend EPI",
        "Kontakt z klientem i historia lekcji",
        "Karnet lekcji / subskrypcja / faktury",
        "Wykres postępów według dyscypliny",
        "Współdzielony dostęp z właścicielem konia",
      ],
      ctaLabel: "Zobacz moduł trenera",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Od WhatsApp i YouTube do EquiSight Trainer.",
      lead: "Konkretnie: tak zmienia się Twój przepływ pracy coachingowej.",
      rows: [
        {
          before: "WhatsApp z luźnymi linkami do filmów",
          after: "Wideo z informacjami zwrotnymi do znacznika czasu w dokumentacji",
        },
        {
          before: "Notatnik dla każdego jeźdźca",
          after: "Dziennik coachingowy z celami i historią",
        },
        {
          before: "Excel z wynikami zawodów",
          after: "Wykres EPI i analiza protokołów",
        },
        {
          before: "Ustne cele",
          after: "Kamienie milowe ze wskaźnikiem postępów",
        },
        {
          before: "Osobne narzędzie do fakturowania",
          after: "Lekcje, iDEAL i subskrypcja w aplikacji",
        },
        {
          before: "E-mail do właściciela o postępach",
          after: "Właściciel śledzi w swoim widoku",
        },
      ],
    },
    helper: {
      title: "Która aplikacja treningowa jest dla Ciebie odpowiednia?",
      lead: "5 pytań, aby sprawdzić, czy specjalistyczne narzędzie coachingowe przyniesie wartość Twojej praktyce.",
      questions: [
        {
          id: "clients",
          q: "Ile aktywnych par trenujesz?",
          options: [
            {
              label: "Mniej niż 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Więcej niż 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Jaka jest Twoja główna dyscyplina?",
          options: [
            {
              label: "Ujeżdżenie",
              score: 3,
            },
            {
              label: "Skoki",
              score: 2,
            },
            {
              label: "Rekreacyjna / różne",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Czy używasz wideo w coachingu?",
          options: [
            {
              label: "Rzadko",
              score: 0,
            },
            {
              label: "Czasami (ręcznie)",
              score: 2,
            },
            {
              label: "Często — systematycznie",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Czy trenujesz jeźdźców startujących w zawodach?",
          options: [
            {
              label: "Nie, rekreacyjnie",
              score: 0,
            },
            {
              label: "Czasami zawody",
              score: 2,
            },
            {
              label: "Dużo — karty startowe na pierwszym miejscu",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Czy chcesz mierzyć swój coaching?",
          options: [
            {
              label: "Nie, intuicja wystarczy",
              score: 0,
            },
            {
              label: "Tak, ale nie mam czasu",
              score: 2,
            },
            {
              label: "Tak — coaching oparty na danych",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Proste narzędzie, a nawet WhatsApp wystarczy — na razie.",
          body: "Przy mniej niż 5 jeźdźcach, bez wielu filmów czy zawodów, aplikacja coachingowa to przesada. EquiSight startuje bezpłatnie, więc możesz wypróbować, gdy Twoja praktyka się rozwinie.",
          cta: "Zacznij bezpłatnie",
        },
        mid: {
          title: "EquiSight Trainer sprawi, że staniesz się strukturalnie bardziej efektywny.",
          body: "Przy 5–15 parach tracisz co miesiąc godziny na WhatsApp i luźne filmy. EquiSight zbiera wszystko razem, automatycznie skanuje protokoły i zapewnia, że jeźdźcy zawsze mogą wrócić do swoich informacji zwrotnych.",
          cta: "Wypróbuj moduł Trainer",
        },
        high: {
          title: "EquiSight jest zbudowany na Twoją skalę coachingową.",
          body: "Wielu jeźdźców, wideo, zawody i coaching oparty na danych: to dokładnie to, w czym EquiSight się wyróżnia. EPI, skan protokołu i dokumentacja konia dają Ci przewagę, której konkurenci nie mają.",
          cta: "Umów demo dla swojej praktyki coachingowej",
        },
      },
    },
    faqTitle: "Często zadawane pytania o aplikacje dla trenerów",
    faq: [
      {
        q: "Jaka jest najlepsza aplikacja treningowa dla koni i jeźdźców?",
        a: "Do czystej komunikacji wiele narzędzi wystarczy (nawet WhatsApp). Dla celów, analizy wideo, skanowania protokołów, śledzenia zawodów i zarządzania klientami w jednym narzędziu EquiSight jest najbardziej kompleksowym rozwiązaniem — szczególnie dlatego, że śledzi samego konia, a nie tylko parę.",
      },
      {
        q: "Czy EquiSight może automatycznie odczytywać protokoły zawodów?",
        a: "Tak. Prześlij protokół KNHS lub FEI, a EquiSight wyodrębni wyniki dla poszczególnych elementów, komentarze sędziów i powiąże je z parą. Trendy widoczne są na przestrzeni wielu zawodów.",
      },
      {
        q: "Czym jest EPI (Equestrian Performance Index)?",
        a: "EPI to wynik EquiSight, który przelicza wyniki z wielu zawodów na porównywalny indeks wydajności. Dzięki temu widzisz rzeczywisty postęp w różnych klasach i przy różnych sędziach.",
      },
      {
        q: "Czy jeźdźcy mogą sami rezerwować lekcje i płacić?",
        a: "Tak. Jeźdźcy logują się, widzą dostępne terminy lekcji, kupują karnety i płacą przez iDEAL. Ty decydujesz, co chcesz oferować.",
      },
      {
        q: "Czy działa też dla instruktora pracującego przy stajni?",
        a: "Tak. Możesz pracować jako niezależny trener z własnymi klientami bez łączenia konta stajni. Klienci płacą bezpośrednio Tobie.",
      },
      {
        q: "Czy mogę przenieść istniejące filmy i notatki?",
        a: "Filmy możesz przesyłać dla każdej pary osobno lub za pomocą narzędzia do zbiorczego przesyłania. Notatki importuje się przez CSV. Pomagamy aktywnym trenerom w jednorazowej migracji.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Przewodniki i narzędzia wyboru oprogramowania do zarządzania końmi | EquiSight",
      description: "Wszystkie przewodniki EquiSight w jednym miejscu: porównania oprogramowania do zarządzania końmi, hodowli, stajni i trenerów oraz narzędzia wyboru na 2026 rok.",
      keywords: [
        "przewodniki oprogramowania dla koni",
        "pomoc w wyborze zarządzania końmi",
        "porównanie oprogramowania hodowlanego",
        "przewodnik po oprogramowaniu dla stajni",
        "porównanie aplikacji dla trenerów",
      ],
    },
    hub: {
      eyebrow: "Hub · przewodniki",
      breadcrumbLabel: "Przewodniki",
      title: "Cztery kompleksowe przewodniki, które pomogą wybrać właściwe oprogramowanie dla koni.",
      intro: "Dla każdej grupy docelowej przygotowaliśmy szczegółowy poradnik wyboru: tabele porównawcze, kryteria, przykłady i interaktywny quiz. Kliknij przewodnik odpowiedni dla Twojej sytuacji lub najpierw zapoznaj się z pogłębionymi artykułami w każdym klastrze.",
      stats: {
        guides: "4 narzędzia wyboru",
        articles: "15 pogłębionych artykułów",
        fair: "Uczciwe porównanie",
      },
      readMoreCta: "Przeczytaj kompletny przewodnik",
      relatedHeading: "Pogłębione artykuły",
      articlesCountSingular: "{{count}} pogłębiony artykuł",
      articlesCountPlural: "{{count}} pogłębione artykuły",
      articlesCountAria: "Liczba artykułów w klastrze",
      lastUpdatedPrefix: "Zaktualizowano",
      lastUpdatedAria: "Data ostatniej aktualizacji tego klastra",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Poradnik wyboru aplikacji do zarządzania końmi",
        blurb: "Porównaj najpopularniejsze aplikacje do zarządzania końmi i sprawdź, która pasuje do właściciela, stajni lub hodowli. Zawiera rzetelną tabelę porównawczą i quiz 5 pytań.",
        audience: "Dla właścicieli, stajennych i wszystkich miłośników koni szukających przejrzystości.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Porównanie oprogramowania hodowlanego",
        blurb: "Od cyklu klaczy po rozwój źrebięcia: sprawdź, które oprogramowanie hodowlane naprawdę sprawdzi się przy Twojej liczbie klaczy, metodzie hodowli i wymaganiach księgi stadnej.",
        audience: "Dla (hobbystycznych) hodowców, stadnin i posiadaczy ogierów.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Poradnik wyboru oprogramowania dla stajni",
        blurb: "Planowanie lekcji, administracja jeźdźców, portal właściciela i fakturowanie — wszystko w jednym narzędziu. Porównaj opcje dla ośrodków jeździeckich i pensjonatów w 2026 roku.",
        audience: "Dla ośrodków jeździeckich, pensjonatów i firm jeździeckich.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Poradnik wyboru aplikacji dla trenerów",
        blurb: "CRM coachingowy, opinie wideo, skanowanie protokołów KNHS i cele dla każdej pary. Która aplikacja trenerska pasuje do Twojej praktyki coachingowej?",
        audience: "Dla instruktorów, trenerów i coachów.",
      },
    ],
    closing: {
      eyebrow: "Dlaczego te przewodniki",
      title: "Uczciwe porównanie, nie tylko ceny.",
      body1: "Wiele \"stron porównawczych\" to zamaskowane reklamy. Nasze przewodniki zestawiają funkcje, grupy docelowe i konkurentów tak, jak zrobiłoby to niezależne źródło wiedzy. EquiSight naturalnie wyróżnia się jako kompleksowe rozwiązanie, ale uczciwie opisujemy również obszary, w których inne aplikacje są mocniejsze.",
      body2: "Pogłębione artykuły w każdym przewodniku odpowiadają na konkretne pytania wynikające z procesu wyboru: \"Kiedy pierwsza echografia po inseminacji\", \"Jak zautomatyzować fakturowanie w stajni\", \"Jak analizować protokół zawodów\". Żadnego marketingowego bełkotu — tylko praktyczna wiedza.",
    },
    hubName: "Przewodniki EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "Dlaczego to boli",
      basics: "Podstawy",
      criteria: "Co decyduje o jakości?",
      comparison: "Uczciwe porównanie",
      why: "Różnica",
      beforeAfter: "Od chaosu do przejrzystości",
      helper: "5 pytań",
    },
    table: {
      feature: "Funkcja",
      today: "Dziś",
      withEquisight: "Z EquiSight",
    },
    helper: {
      questionLabel: "Pytanie {{current}} z {{total}}",
      answerPrompt: "Odpowiedz na {{count}} pozostałe pytanie, aby zobaczyć rekomendację.",
      answerPromptPlural: "Odpowiedz na {{count}} pozostałe pytania, aby zobaczyć rekomendację.",
      resultEyebrow: "Twój wynik",
    },
    targetGroupsFallback: "Dla kogo jest to przeznaczone?",
    faqTitleFallback: "Często zadawane pytania",
  },
};

export default CORNERSTONES;
